import { FETCH_COLLECTION_PAGE_NECKLACE_FIELDS } from "./types";

import ContentfulApi from "../../lib/ContentfulApi";

export const fetchCollectionPageNecklaceFields = () => {
  return (dispatch) => {
    const api = new ContentfulApi();

    api
      .getCollectionPageNecklaceFields()
      .then((response) => {
        dispatch({
          type: FETCH_COLLECTION_PAGE_NECKLACE_FIELDS,
          payload: response,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};
